// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '@codex/basics';

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 5px 15px 0 15px;
`;

const ListItem = styled.li`
  margin: 0 5px 5px 0;

  &:last-child {
    border-right: 0;
  }
`;

const ListLink = styled(Link)`
  background-color: ${({ theme }) => theme.colors.message.hover};
  border: 1px solid ${({ theme }) => theme.colors.link.default};
  color: ${({ theme }) => theme.colors.header.nav.mobile.typeLink};
  border-radius: 10px;
  padding: 8px 15px;
  display: block;
  font-size: 14px;

  &:hover {
    text-decoration: none;
  }
`;

const TypeList = (props) => {
  const { items } = props;

  return (
    <List>
      {
        items.map((item, i) => (
          <ListItem key={i}>
            <ListLink href={item.link}>
              {item.label}
            </ListLink>
          </ListItem>
        ))
      }
    </List>
  );
};
TypeList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string
    })
  ).isRequired
};

export default TypeList;
